import { SortType } from '@plugins/shared/types/sort';

export const DEFAULT_COMMENT_PAGE_SIZE = 10;

/**
 * The four options the imported `post-comments` component offers by default.
 * Popularity is backed by comment likes, so none of them mis-sorts.
 */
export const COMMENT_SORT_OPTIONS: SortType[] = [
  SortType.NEW_OLD,
  SortType.OLD_NEW,
  SortType.POPULAR,
  SortType.UNPOPULAR,
];

export const DEFAULT_COMMENT_SORT = SortType.NEW_OLD;

/** Blob container folder for attachments uploaded on a comment or reply. */
export const COMMENT_UPLOAD_FOLDER = 'comments';
